import { MatDialog } from '@angular/material'
import { ViewValidation } from './../../../_helpers/ViewValidation'
import { Component, Input, OnInit, Output } from '@angular/core'
import * as moment from 'moment'


@Component({
	selector: 'app-insert-date',
	templateUrl: './insert-date.component.html',
	styleUrls: ['./insert-date.component.scss']
})


export class InsertDateComponent implements OnInit {
	@Output() public dateStart: string = moment()
		.subtract(1, 'months')
		.format('DD/MM/YYYY')
	@Input() public close: () => void
	@Output() public dateEnd: string = moment().format('DD/MM/YYYY')
	@Output() public cancel: boolean = true
	public ViewValidation: ViewValidation = new ViewValidation()

	constructor(
		private dialogRef: MatDialog
	) { }

	public ngOnInit() {
		const dialogmodal = document.getElementsByClassName('mat-dialog-container')[0].id
		document.getElementById(dialogmodal).classList.remove('mat-dialog-container')
	}

	public closeModal() {
		this.cancel = true
		this.dialogRef.closeAll()
	}

	public send() {
		this.cancel = false
		this.dialogRef.closeAll()
	}

	public validateDate(): boolean {
		const start = this.ViewValidation.isValidDate(this.dateStart)
		const end = this.ViewValidation.isValidDate(this.dateEnd)

		if (start && end) {
			return true
		}

		return false
	}
}
